<script setup lang="ts">

import {useModalStore} from "../../../store/modal";
import {useChatStore} from "../../../store/chat";
import DefaultModalBase from "../DefaultModalBase.vue";
import {ref} from "vue";

const store = useChatStore()
const modalStore = useModalStore()
const is_complete = ref(false)
const loading = ref(false)

const completeChat = async () => {
    loading.value = true
    if (typeof modalStore.props?.id === 'object') {
        await store.bulkCompleteChats(modalStore.props?.id)
    } else {
        await store.completeChat(modalStore.props?.id)
    }
    is_complete.value = true
    loading.value = false
}
</script>

<template>
    <DefaultModalBase :heading="'Are you sure you want to close this chat?'" icon="check-all" :loading
                      :refresh="is_complete">
        <div class="complete-ticket-actions">
            <brand-button @click="completeChat()" v-if="!is_complete">Yes, mark as complete</brand-button>
            <brand-button variant="secondary" @click="modalStore.close(is_complete)">
                {{ !is_complete ? "Nevermind" : "Done" }}
            </brand-button>
        </div>
    </DefaultModalBase>
</template>

<style scoped lang="scss">
.complete-ticket-actions {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
</style>
